module.exports = __webpack_public_path__ + "static/why-content-image-10-1b0b9d90a201cb77e97409fd6e0f6e45.svg";